import React, { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function HotSteals() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products?hot=true").then(({ data }) => setProducts(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="px-4 py-6">
      <div className="flex items-center gap-3 mb-5">
        <Flame size={30} className="text-[#E60000]" />
        <h1 className="font-heading font-black uppercase text-3xl text-[#F0EDEA]">Hot Steals</h1>
      </div>
      {loading ? (
        <div className="text-[#A8A2A0] text-center py-16">Loading...</div>
      ) : products.length === 0 ? (
        <div className="text-[#A8A2A0] text-center py-16" data-testid="no-hotsteals">No hot steals right now. Check back soon.</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-testid="hotsteals-grid">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
